module.exports = __webpack_public_path__ + "static/media/resourcesSymptom.8415b92f.png";